// Shared modal-open guard (Batch 1, item 6).
//
// The calls pages auto-refresh on a 30s interval. When that refresh runs while
// a modal is open (save-client, start-opportunity, transfer, call detail,
// follow-up), the re-render can unmount the modal and lose typed data. Any
// modal registers itself here on open and unregisters on close; the refresh
// interval calls anyModalOpen() and skips the tick while one is up.
//
// A counter (not a boolean) so overlapping/nested modals are handled correctly.

let openCount = 0;

export const modalOpen = () => { openCount += 1; };
export const modalClosed = () => { openCount = Math.max(0, openCount - 1); };
export const anyModalOpen = () => openCount > 0;
